import { moment } from 'fullcalendar';

const axios = require('axios');

const api_link = 'https://lk-api.actid.ru';

const route = r => api_link + (r[0] == '/' ? r : `/${r}`);

/**
 * GET-запрос к API
 * @param {*} r - route, transactions/list
 * @param {*=} params - параметры запроса
 */
async function get(r, params) {
  if (!params) params = {};
  let token = getToken();
  let _route = route(r);
  if (_route.includes(api_link + '/admin/') && localStorage.returnAdminToken) token = localStorage.returnAdminToken;
  try {
    const { data } = await axios.default.get(_route, { params, headers: { token } });
    if (data.done === false) {
      console.error('apiDriver error:', r, data.error);
      return false;
    }
    return data;
  } catch (e) {
    return false;
  }
}

/**
 * POST-запрос к API
 * @param {*} r - route, transactions/list
 * @param {*=} params - параметры запроса
 */
async function post(r, params) {
  if (!params) params = {};
  params.token = getToken();
  let _route = route(r);
  if (_route.includes(api_link + '/admin/') && localStorage.returnAdminToken) params.token = localStorage.returnAdminToken;
  try {
    const { data } = await axios.default.post(_route, params);
    if (data.done === false) {
      console.error('apiDriver error:', r, data.error);
      return false;
    }
    return data;
  } catch (e) {
    return false;
  }
}

/**
 * Получение токена аутентификации пользователя
 */
function getToken() {
  const t = localStorage.token;
  return t ? t.toString() : '';
}

export default {
  getToken,
  checkAuth: async () => {
    const account = await get('account');
    return account;
  },

  /**
       * Вся информация об аккаунте
       */
  account: async () => await get('account'),

  login: async (email, password) => {
    try {
      const { data } = await axios.default.post(route('auth'), { email, password });
      if (data.done === false) {
        return false;
      }
      return data;
    } catch (e) {
      return false;
    }
  },

  logout: async () => {
    await post('logout');
  },

  signup: async form_data => await post('signup', form_data),

  settings: {
    updateAccount: async params => await post('/account/update', params),
    updatePassword: async params => await post('/account/updatePassword', params),
  },

  /**
       * Базовая информация об пользователе аккаунта
       */
  user: async () => await get('account/user'),

  statistics: {
    cards: {
      card_emit_per_day: async (date_start, date_end) => {
        if (!date_start) date_start = moment().add(-7, 'days');
        if (!date_end) date_end = moment();
        console.log('date_start ->', date_start);
        if (date_start) date_start = date_start.toDate();
        if (date_end) date_end = date_end.toDate();

        return await get('statistics/cards/card_emit_per_day', { date_start, date_end });
      },
      emit_cards_count: async (date_start, date_end) => {
        if (date_start) date_start = date_start.toDate();
        if (date_end) date_end = date_end.toDate();
        return await get('statistics/cards/emit_cards_count', { date_start, date_end });
      },
      pushes_sent_count: async (date_start, date_end) => {
        if (date_start) date_start = date_start.toDate();
        if (date_end) date_end = date_end.toDate();
        return await get('statistics/cards/pushes_sent_count', { date_start, date_end });
      },
      tabletent_scan_count: async (date_start, date_end) => {
        if (date_start) date_start = date_start.toDate();
        if (date_end) date_end = date_end.toDate();
        return await get('statistics/cards/tabletent_scan_count', { date_start, date_end });
      },
      average_gender: async (date_start, date_end) => {
        if (date_start) date_start = date_start.toDate();
        if (date_end) date_end = date_end.toDate();
        return await get('statistics/cards/average_gender', { date_start, date_end });
      },
      average_age: async (date_start, date_end) => {
        if (date_start) date_start = date_start.toDate();
        if (date_end) date_end = date_end.toDate();
        return await get('statistics/cards/average_age', { date_start, date_end });
      },
      devices: async (date_start, date_end) => {
        if (date_start) date_start = date_start.toDate();
        if (date_end) date_end = date_end.toDate();
        return await get('statistics/cards/devices', { date_start, date_end });
      },
      birthdays: async (date_start, date_end) => {
        if (date_start) date_start = date_start.toDate();
        if (date_end) date_end = date_end.toDate();
        return await get('statistics/cards/birthdays', { date_start, date_end });
      },
    },
    /**
             * Вся статистика по заведению на дашборд
             */
    all: async () => {
      return false;
      return await get('statistics');
    },
  },
  pushes: {
    /**
             * Получение списка пушей, который только предстоит отправить
             */
    future: async () => await get('pushes/future'),

    /**
             * Отправка пушей гостям
             *
             * @param {Object} params - парамерты пушей
             * @param {String} params.datetime - Дата отправки: now/YYYY-MM-DD HH:MM:SS
             * @param {(String|Array)} params.cards - Карты: "all"/69/["123",...]
             * @param {String=} params.text - Текст для отправки - без текста будет просто обновление карт
             */
    make: async (params) => {
      if (!params) return false;
      if (!params.cards) return false;
      if (!params.datetime) params.datetime = 'now';
      return await post('subscriptions/add', params);
    },
  },
  services: {
    /**
             * Список всех сервисов
             */
    list: async () => await get('services/list'),
    api: {
      post: async (service_type, route, params) => await post('services/api/post', { service_type, route, params }),
      get: async (service_type, route, params) => await get('services/api/get', { service_type, route, params }),
    },
  },
  subscriptions: {
    /**
             * Список активных подписок
             */
    list: async () => await get('subscriptions/list'),
    /**
             * Добавление подписки по номеру сервиса
             * @param {number|string} service_id - ID сервиса
             */
    add: async service_id => await post('subscriptions/add', { service_id }),
    /**
             * Удаление подписки по номеру сервиса
             * @param {number|string} service_id - ID сервиса
             */
    remove: async service_id => await post('subscriptions/remove', { service_id }),
    /**
             * Возвращает информацию о том, сколько примерно дней осталось на работу подписок
             */
    days_left: async () => await get('subscriptions/days_left'),
  },
  transactions: {
    /**
             * Возвращает последние транзакции
             */
    list: async () => await get('transactions/list'),
    /**
             * Возвращает сколько средств осталось
             */
    available: async () => await get('transactions/available'),
    /**
             * Проверка на возможность снятия средств со счета
             * @param {number} amount - количество средств
             * @param {string=} type - тип снимаемых средств: any, real, bonus
             */
    check_withdraw_availability: async (amount, type) => {
      if (!type) type = 'any';
      return await get('transactions/check_withdraw_availability', { amount, type });
    },
    /**
             * Возвращает ответ: была ли произведена первая оплата. Если нет, то оплачивать нужно по счету, а если да, то можно и картой
             */
    is_real_paid_already: async () => await get('transactions/is_real_paid_already'),
  },
  documents: {
    contract: async () => await get('documents/contract'),
    bills: async () => await get('documents/bills'),
    acts: async () => await get('documents/acts'),
    legal_entity: async () => await get('documents/legal_entity'),
    create_contract: async params => await post('documents/create_contract', params),
    uploadContract: async (formData) => {
      try {
        const u = await axios.default.post(route('documents/uploadContract'), formData, { headers: { 'Content-Type': 'multipart/form-data', token: getToken() } });
        return u.data;
      } catch (error) {
        return false;
      }
    },
  },
  payments: {
    /**
             * Запрос pdf-счёта у сервера
             */
    get_bill: async (amount) => {
      if (!amount) return false;
      return await get('payments/get_bill', { amount });
    },
    require_card_payment: async (amount, save_card_payment) => {
      if (!amount) return false;
      return await get('payments/require_card_payment', { amount, save_card_payment });
    },
    get_fast_bank_cards: async () => await get('payments/get_fast_bank_cards'),
    fast_bank_card_payment: async (amount, bank_card_id) => {
      if (!amount) return false;
      return await post('payments/fast_bank_card_payment', { amount, bank_card_id });
    },
  },
  connections: {
    list: async () => await get('connections/list'),
    remove: async connection_id => await post('connections/remove', { connection_id }),
    add_ticket: async (name, phone, system, communicate_by) => await post('connections/add_ticket', {
      name, phone, system, communicate_by,
    }),
    connect_token: async connection_token => await post('connections/connect_token', { connection_token }),
  },
  upload: {
    image: async (formData) => {
      try {
        const u = await axios.default.post(route('upload/image'), formData, { headers: { 'Content-Type': 'multipart/form-data', token: getToken() } });
        return u.data;
      } catch (error) {
        return false;
      }
    },
  },
  acts: {
    get: async () => await get('acts/'),
  },
  admin: {
    users: {
      list: async () => await get('admin/users/list'),
      loginAs: async email => await post('admin/users/loginAs', { email }),
      getTransactions: async () => await get('/admin/users/getTransactions'),
      getIncomeTransactions: async () => await get('/admin/users/incomeTransactions'),
      addMoney: async (user_id, amount, type, comment) => await post('admin/users/addMoney', {
        user_id, amount, type, comment,
      }),
      changePassword: async (user_id, password) => await post('admin/users/changePassword', {
        user_id, password,
      }),
      legal: {
        get: async user_id => await get('admin/users/legal', { user_id }),
        signContract: async contract_id => await post('admin/users/legal/signContract', { contract_id }),
      },
      cardsCerts: {
        get: async () => await get('admin/users/getCardsCertsExpire'),
        refresh: async user_id => await post('admin/users/updateCardsCert', { user_id }),
      },
    },
    franchise: {
      getSettings: async () => await get('admin/franchise/settings'),
      saveSettings: async settings => await post('admin/franchise/settings', { settings }),
    },
  },
};
